export type TNativeEventTarget = EventTarget;
